import React, {useState, useEffect } from 'react';
import {useSelector} from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import {ButtonTextMUI as Button} from "utils/componentsStyle";
import api from "utils/API";

// Lista de documentos adjuntos a una solicitud, a partir del id de la tarea
// (misma consulta que ya usaba ModalProgressExtra: GET /api/documentospaciente/
// filtrado por tarea_paciente, que el backend resuelve a la solicitud de esa
// tarea). Pensado para reusarse en cualquier modal de tarea de gestión
// clínica (permiso ResponderSolicitudesExtras) que hoy no muestra los
// documentos adjuntos de la solicitud que está revisando.
export default function DocumentosAdjuntosTarea({idTarea, reloadTrigger}) {
    const [listFile, setlistFile] = useState([]);
    const dictTypeFile = useSelector(state => state.currentList.DICCIONARIO_TIPO_ARCHIVO_PACIENTE);

    useEffect(() => {
        if (!idTarea) {
            return;
        }
        api.get(`api/documentospaciente/?tarea_paciente=${idTarea}`).then(response => {
            setlistFile(response.data)
        });
    }, [idTarea, reloadTrigger]);

    const handleDownloadFile = (link) => {
        window.open(link)
    }

    if (!idTarea) {
        return null;
    }

    return (
        <Grid item container xs={12} justify="center" style={{margin: "10px 0"}}>
            {listFile.length === 0 && <Typography variant="body2">Sin documentos adjuntos</Typography>}
            {listFile.map((row) => (
                <Grid item xs={12} key={row.id}>
                    <Button
                        variant="outlined"
                        color="primary"
                        title={`Descargar ${dictTypeFile[row.tipo_documento]?.label || row.tipo_documento}: ${row.nombre_archivo}`}
                        style={{margin: "5px", width: "100%", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "none"}}
                        onClick={() => handleDownloadFile(row.archivo)}
                    >
                        {`Descargar ${dictTypeFile[row.tipo_documento]?.label || row.tipo_documento}: ${row.nombre_archivo}`}
                    </Button>
                </Grid>
            ))}
        </Grid>
    );
}
